import { useIntl } from 'react-intl';
const useMultiLanguageAccountLog = () => {
  const intl = useIntl();
  const ACCOUNT_LOG_LIST_TITLE = intl.formatMessage({
    id: 'authentication.accountLogList.title',
  });
  const ACCOUNT_LOG_LIST_PLACEHOLDER_SEARCH = intl.formatMessage({
    id: 'authentication.accountLogList.placeholderSearch',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE = intl.formatMessage({
    id: 'authentication.accountLogList.table.accountAccessRanking.pageTitle',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME = intl.formatMessage({
    id: 'authentication.accountLogList.table.accountAccessRanking.productName',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_COUNT = intl.formatMessage({
    id: 'authentication.accountLogList.table.accountAccessRanking.count',
  });
  const ACCOUNT_LOG_TABLE_ID = intl.formatMessage({
    id: 'authentication.accountLogList.table.id',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_URL = intl.formatMessage({
    id: 'authentication.accountLogList.table.fileDownloadRanking.url',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE = intl.formatMessage({
    id: 'authentication.accountLogList.table.fileDownloadRanking.detailTitle',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME = intl.formatMessage({
    id: 'authentication.accountLogList.table.fileDownloadRanking.productName',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_COUNT = intl.formatMessage({
    id: 'authentication.accountLogList.table.fileDownloadRanking.count',
  });
  return {
    ACCOUNT_LOG_LIST_TITLE,
    ACCOUNT_LOG_LIST_PLACEHOLDER_SEARCH,
    ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE,
    ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME,
    ACCOUNT_ACCESS_RANKING_TABLE_COUNT,
    ACCOUNT_LOG_TABLE_ID,
    FILE_DOWNLOAD_RANKING_TABLE_URL,
    FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE,
    FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME,
    FILE_DOWNLOAD_RANKING_TABLE_COUNT,
  };
};
export default useMultiLanguageAccountLog;
